import React from 'react'
import styled from 'styled-components'

const TabsWrapper = styled.div`
  margin: 26px 0 40px;
`

export default TabsWrapper